// create slices
import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../../services/api-status.enum";

const initialState = {
  getApplicationDetail: {
    data: [],
    status: ApiStatus.NONE,
    error: null,
  },
};

const getApplicationDataSlice = createSlice({
  name: "getApplicationData",
  initialState,
  reducers: {
    getApplicationData: (state) => {
      state.getApplicationDetail.status = ApiStatus.LOADING;
      state.getApplicationDetail.error = null;
    },
    getApplicationDataSuccess: (state, action) => {
      state.getApplicationDetail.data = action.payload;
      state.getApplicationDetail.status = ApiStatus.SUCCESS;
      state.getApplicationDetail.error = null;
    },
    getApplicationDataFailure: (state, action) => {
      state.getApplicationDetail.status = ApiStatus.FAILURE;
      state.getApplicationDetail.error = action.payload;
    },
  },
});

export const {
  getApplicationData,
  getApplicationDataSuccess,
  getApplicationDataFailure,
} = getApplicationDataSlice.actions;
export default getApplicationDataSlice.reducer;
